module.exports = __webpack_public_path__ + "img/empty.b147fff.png";